const GA4_ID = import.meta.env.VITE_GA4_ID;

let initialized = false;

/** Inject gtag.js script and initialize GA4 (call only after consent) */
export function initGA4() {
  if (!GA4_ID || initialized) return;
  initialized = true;

  // Load gtag.js
  const script = document.createElement("script");
  script.async = true;
  script.src = `https://www.googletagmanager.com/gtag/js?id=${GA4_ID}`;
  document.head.appendChild(script);

  // Initialize dataLayer
  window.dataLayer = window.dataLayer || [];
  window.gtag = function () {
    // eslint-disable-next-line prefer-rest-params
    window.dataLayer.push(arguments);
  };
  window.gtag("js", new Date());
  window.gtag("config", GA4_ID, { send_page_view: false });
}

/** Track SPA page view */
export function trackPageView(path: string) {
  if (!GA4_ID || !window.gtag) return;
  window.gtag("event", "page_view", { page_path: path });
}

/** Track custom event (e.g. form submission) */
export function trackEvent(name: string, params?: Record<string, unknown>) {
  if (!GA4_ID || !window.gtag) return;
  window.gtag("event", name, params);
}

// Extend Window for gtag
declare global {
  interface Window {
    dataLayer: unknown[];
    gtag: (...args: unknown[]) => void;
  }
}
